// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';

// import * as serviceWorker from './serviceWorker';

// ReactDOM.render(<App />, document.getElementById('root'));

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();



// import React from "react";
// import ReactDOM from "react-dom";
// import { Provider } from "react-redux"; // Import Redux Provider
// import store from "./store"; // Import the configured Redux store
// import App from "./App";

// import * as serviceWorker from "./serviceWorker";

// // Wrap the App component with the Redux Provider and pass the store
// ReactDOM.render(
//   <Provider store={store}>
//     <App />
//   </Provider>,
//   document.getElementById("root")
// );

// // Enable service worker (optional, depends on your app needs)
// serviceWorker.unregister();



// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import { AuthProvider } from './context/AuthContext'; // Import AuthProvider
// import * as serviceWorker from './serviceWorker';

// ReactDOM.render(
//   <AuthProvider> {/* Wrap App with AuthProvider */}
//     <App />
//   </AuthProvider>,
//   document.getElementById('root')
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();

// import React from 'react';
// import ReactDOM from 'react-dom';
// import { Provider } from 'react-redux'; // Import Redux Provider
// import { createStore } from 'redux';

// import App from './App';
// import { AuthProvider } from './context/AuthContext'; // Import AuthProvider
// import rootReducer from './reducers'; // Import your root reducer
// import * as serviceWorker from './serviceWorker';

// // Create the Redux store
// const store = createStore(rootReducer);

// ReactDOM.render(
//   <Provider store={store}> {/* Provide the Redux store */}
//     <AuthProvider> {/* Wrap with AuthProvider */}
//       <App />
//     </AuthProvider>
//   </Provider>,
//   document.getElementById('root')
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();



// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store'; // Update to use configureStore setup

import App from './App';
import { AuthProvider } from './context/AuthContext';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <Provider store={store}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
